<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="Unidades Administrativos"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/hierarchy.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/unidades', login.orgao.id]" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 250px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/contabil/building.png" alt="liquida">
        </div>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="codigou">Código</label>
              <span #codigo id="codigou"
                class="form-control-plaintext font-weight-bold">{{funcaoService.mascarar('##.##.##',entidade.codigo)}}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-9">
              <label for="nomeu">Nome</label>
              <span id="nomeu" class="form-control-plaintext font-weight-bold">{{entidade.nome}}</span>
            </div>
            <div class="form-group col-md-3">
              <label for="tribunalu">N˚ TCE</label>
              <span id="tribunalu" class="form-control-plaintext font-weight-bold">{{entidade.tribunal}}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="ato">Ato jurídico</label>
              <span *ngIf='ato' id="ato" class="form-control-plaintext">{{ato.nome}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 150px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/contabil/administrator.png" alt="liquida">
        </div>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="form-row">
            <div class="form-group col-md-8">
              <label for="responsavel">Responsável</label>
              <span id="responsavel" class="form-control-plaintext">{{entidade.responsavel}}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-5">
              <label for="cargo">Cargo</label>
              <span id="cargo" class="form-control-plaintext">{{entidade.cargo}}</span>
            </div>
            <div class="form-group col-md-3">
              <label for="cpf">CPF</label>
              <span id="cpf"
                class="form-control-plaintext">{{funcaoService.mascarar('###.###.###-##', entidade.cpf)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 150px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/contabil/account_balances.png" alt="ordenador">
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
          <div class="row">
            <div class="col-12">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="ordenador">Ordenador da despesa</label>
                  <span id="ordenador" class="form-control-plaintext">{{entidade.ordenador}}</span>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="cargo_ordenador">Cargo</label>
                  <span id="cargo_ordenador" class="form-control-plaintext">{{entidade.cargo_ordenador}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="offset-1 col-md-5 col-lg-5 col-xl-5">
          <div class="col-12">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="tesoureiro">Tesoureiro</label>
                <span id="tesoureiro" class="form-control-plaintext">{{entidade.tesoureiro}}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="cargo_tesoureiro">Cargo</label>
                <span id="cargo_tesoureiro" class="form-control-plaintext">{{entidade.cargo_tesoureiro}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <table class="table table-eddy mt-5" *ngIf="listaExecutoras && listaExecutoras.length > 0">
        <thead>
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Nome</th>
            <th scope="col">tribunal N˚</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaExecutoras; let idx = index">
            <td style="width: 200px">{{item.codigo}}</td>
            <td style="width: 60%">{{item.nome}}</td>
            <td style="width: 200px">{{item.tribunal}}</td>
          </tr>
        </tbody>
      </table>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>
